const styles = (theme) => ({
  link: {
    '-webkit-tap-highlight-color': 'transparent',
    fontSize: 16,
    color: theme.color.black_11,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  disabledLink: {
    cursor: 'default',
  },
  icon: {
    width: 20,
    height: 20,
  },
  text: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',

    '&:last-child': {
      minHeight: 20,
    },
  },
  disabledText: {
    color: theme.color.grey_36,
  },
  activeAvatar: {
    background: theme.color.teal,
    fill: theme.color.white,
  },
  avatar: {
    background: theme.color.black_11,
    fontSize: 16,
  },
  disabledAvatar: {
    background: theme.color.grey_36,
  },
});

export default styles;
